import Input from "@/components/atoms/input";
import * as ViewModel from '@/core/presenter/viewModel';
import { MAX_PHONE_NUMBER_LENGTH_WITH_HYPHEN } from "@/consts";
import Button from "@/components/atoms/button";


interface IProps {
    phoneNumber: string;
    phoneNumGuideMsg: string;
    countryNumber: string;
    onChangePhoneNumber: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onClickRequestBtn: () => void;
}

const InputPhone = ({phoneNumber, phoneNumGuideMsg, countryNumber, onChangePhoneNumber, onClickRequestBtn}: IProps): JSX.Element => {
    if (phoneNumGuideMsg === '') {
        phoneNumGuideMsg = '중복확인을 눌러주세요';
    }

    return (
        <div className="form-group-join-sms-2">
            <label htmlFor="phone" className="w body-n-n pad-b mar-b">정보를 입력해주세요.</label>
            <div className="input-group-join-sms-2">
                <span id="nation-code" className="nation-code body-n-n ml-gray">{countryNumber}</span>
                <Input 
                    type='text' 
                    className="pnum-input body-n-n ml-gray" 
                    placeholder="010-0000-0000" 
                    value={phoneNumber} 
                    onChange={onChangePhoneNumber}
                    validatorType={ViewModel.InputValidatorType.NUMBER_ONLY} 
                    maxLength={MAX_PHONE_NUMBER_LENGTH_WITH_HYPHEN} 
                />
                <Button 
                    caption={"중복확인"} 
                    className="request-button body-s-n" 
                    onClick={onClickRequestBtn} 
                />
            </div>
            <div className="alert-msg-join-sms-2 body-s-n">
                <p>{phoneNumGuideMsg}</p>
            </div>
        </div>
    )
}

export default InputPhone;